import { render, staticRenderFns } from "./Inductors.vue?vue&type=template&id=74ff59ce&lang=true"
import script from "./Inductors.vue?vue&type=script&lang=js"
export * from "./Inductors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports